import { Dialog } from "primereact/dialog";
import { ButtonContent } from "../AdminReportStyle";
import {
  ReportLoadingReport,
  ReportProcessingContainer,
  ReportProcessingContent,
} from "./ModalGenerateReportStyled";
import GifDownloadReport from "../../../images/gif_download_talma.gif";
import CloseModal from "../../../images/icon_close_modal.svg";
interface Props {
  showProcessing: boolean;
  onAccept: () => void;
  onClose: () => void;
}
export const ModalGenerateReport = ({
  showProcessing = false,
  onAccept,
  onClose,
}: Props) => {
  return (
    <Dialog
      style={{ width: "45rem", height: "32rem" }}
      className="img-processing-talma-class"
      showHeader={false}
      visible={showProcessing}
      onHide={() => {}}
      draggable={false}
      resizable={false}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ReportLoadingReport>
          <img
            src={GifDownloadReport}
            alt="download"
            className="img-processing-report"
          />
        </ReportLoadingReport>
      </div>
      <ReportProcessingContainer>
        <div className="close-modal-button">
          <img
            src={CloseModal}
            alt="close modal"
            className="close-button"
            onClick={() => {
              onClose();
            }}
          />
        </div>
        <ReportProcessingContent>
          <h1>Estamos generando tu reporte</h1>
          <p>
            <strong>Para generar tu reporte haz click en confirmar. </strong>
            Recuerda que para visualizar tus descargas debes ir a{" "}
            <strong>
              <u> “Ver descargas”</u>
            </strong>
          </p>
          <ButtonContent
            onClick={() => {
              onAccept();
            }}
            backgroundColor="#76BC21"
            width="36.6rem"
            height="5.6rem"
            marginTop="2rem"
          >
            {"Confirmar"}
          </ButtonContent>
        </ReportProcessingContent>
      </ReportProcessingContainer>
    </Dialog>
  );
};
